import { ProductPersonalizationAdditionAddressRequirements } from './product-personalization-addition-address-requirements';

export type ProductPersonalizationAdditionBirthDateRequirement = 'NONE' | 'FIRST_PERSON';

export interface ProductPersonalizationAddition {
  type: 'PERSONALIZATION';
  maxNumberOfPersons: number;
  birthDateRequirement: ProductPersonalizationAdditionBirthDateRequirement;
  addressRequirements: ProductPersonalizationAdditionAddressRequirements | null;
  mustIncludeUser: boolean;
}
